import { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Col, Row } from 'react-bootstrap';
import { InputSwitch } from 'primereact/inputswitch';

// props:
// - visible
// - driver
// - onHide
// - onDriverSaved
function DriverEditDialog(props) {

  // #region const and vars

  const [isNew, setIsNew] = useState(false);
  const [active, setActive] = useState(true);
  const defaultValues = {
    firstName: '',
    lastName: '',
    phoneNumber: ''
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm({ defaultValues });
  
  // #endregion

  // #region methods

  const resetForm = () => {
    reset(defaultValues);
  }

  const createDriver = (
    firstName,
    lastName,
    phoneNumber,
    avatar,
    active) => {
    fetch(`${process.env.REACT_APP_API_URL}/airportService/v1/driver/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName,
        lastName,
        phoneNumber,
        avatar,
        active
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("DriverEditDialog: createDriver: success");
        props.onDriverSaved();
        reset();
      } else {
        console.log("DriverEditDialog: createDriver: error");
      }
    });
  };

  const updateDriver = (
    driverId,
    firstName,
    lastName,
    phoneNumber,
    avatar,
    active) => {
    fetch(`${process.env.REACT_APP_API_URL}/airportService/v1/driver/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        driverId,
        firstName,
        lastName,
        phoneNumber,
        avatar,
        active
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("DriverEditDialog: updateDriver: success");
        props.onDriverSaved();
        reset();
      } else {
        console.log("DriverEditDialog: updateDriver: error");
      }
    });
  };

  const getFormErrorMessage = (name) => {
    return errors[name] && (
      <small className="p-error">
        {errors[name].message}
      </small>
    )
  };

  // #endregion

  // #region events

  const onDialogHide = () => {
    if (props.onHide) props.onHide();
  };

  const onFormSubmit = (data) => {
    if (isNew) {
      createDriver(        
        data.firstName,
        data.lastName,
        data.phoneNumber,
        '',
        active);
    } else {
      updateDriver(
        props.driver.driverId,
        data.firstName,
        data.lastName,
        data.phoneNumber,
        '',
        active);
    }
  };

  // #endregion

  // #region templates

  const formTemplate = (
    <>
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="p-fluid">
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="firstName"
              className={classNames({ 'p-error': errors.firstName })}>
              Nombres*
            </label>
            <Controller
              name="firstName"
              control={control}
              rules={{ required: 'Los nombres son requeridos.' }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  autoFocus
                  maxLength={255}
                  className={classNames({ 'p-invalid': fieldState.invalid })} />
              )} />
            {getFormErrorMessage('firstName')}
          </Col>
        </Row>
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="lastName"
              className={classNames({ 'p-error': errors.lastName })}>
              Apellidos*
            </label>
            <Controller
              name="lastName"
              control={control}
              rules={{ required: 'Los apellidos son requeridos.' }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  autoFocus
                  maxLength={255}
                  className={classNames({ 'p-invalid': fieldState.invalid })} />
              )} />
            {getFormErrorMessage('lastName')}
          </Col>
        </Row>
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="phoneNumber"
              className={classNames({ 'p-error': errors.phoneNumber })}>
              Número telefónico*
            </label>
            <Controller
              name="phoneNumber"
              control={control}
              rules={{ required: 'El número telefónico es requerido.' }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  autoFocus
                  maxLength={255}
                  className={classNames({ 'p-invalid': fieldState.invalid })} />
              )} />
            {getFormErrorMessage('phoneNumber')}
          </Col>
        </Row>
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="active">
              Activo
            </label>
            <br></br>
            <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
          </Col>
        </Row>
        <Button
          type="submit"
          label="Guardar"
          className="p-button-raised p-button-sm mt-4" />
      </form>
    </>
  );

  const dialogTemplate = (
    <>
      <Dialog
        header=""
        visible={props.visible}
        onHide={onDialogHide}
        breakpoints={{ '960px': '75vw' }}
        style={{ width: '50vw' }}>
        <h1>Conductor</h1>
        {formTemplate}
      </Dialog>
    </>
  );

  // #endregion

  useEffect(() => {
    resetForm();    
    if (props.driver) {
      setIsNew(false);
      reset(props.driver);
    } else {
      setIsNew(true);
    }
  }, [props.visible, props.driver]);

  return (
    <>
      <article>
        {dialogTemplate}
      </article>
    </>
  );
}

export default DriverEditDialog;